var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expand-transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hide),expression:"!hide"}],ref:"container",class:_vm.fixed && !_vm.collapsed ? 'elevation-8' : '',style:(_vm.getStyle)},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }